var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 27.5H19.1667V45.8334H25.8334V27.5Z",
    fill: "#043873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 34.1667H39.1667V45.8334H45.8334V34.1667Z",
    fill: "#043873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8334 19.1667H29.1667V45.8334H35.8334V19.1667Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestion);
export default __webpack_public_path__ + "static/media/gestion.328a5ed436bf772b06fc20cd443223d8.svg";
export { ForwardRef as ReactComponent };